import RightsPopoverSelector from "./RightsPopoverSelector";

export default RightsPopoverSelector;
